import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import classNames from "classnames";

import { HeaderContext } from "config/contexts";
import { getLatestStories } from "../../../actions/latestStories";
import MiniStoryCard from "../MiniStoryCard";
import Spinner from "../Spinner";
import Ad from "components/Library/Ad";
import styles from "./LatestStories.css";

class LatestStories extends Component {
  componentDidMount() {
    const { getLatestStories, latestStories } = this.props;
    if (latestStories.results.length === 0) {
      getLatestStories();
    }
  }

  renderPromo() {
    return (
      <div className={styles.promo}>
        <Ad adUnit="sidebar" slotSize={[300, 275]} />
      </div>
    );
  }

  render() {
    const { latestStories, className } = this.props;
    if (latestStories.results.length === 0) {
      if (latestStories.isLoading) {
        return <Spinner />;
      }
      return null;
    }

    const latestSorted = [...latestStories.results].sort((a, b) =>
      new Date(a.published_date).getTime() >
      new Date(b.published_date).getTime()
        ? -1
        : 1
    );

    return (
      <HeaderContext.Consumer>
        {headerLevels => {
          const HeadingTag = "h" + headerLevels.latestStoriesHeader;
          return (
            <div className={className}>
              <HeadingTag
                className={classNames(styles.heading, styles.hiddenLarge)}
              >
                Latest Stories
              </HeadingTag>
              <div className={styles.root}>
                <HeadingTag
                  className={classNames(styles.heading, styles.hiddenSmall)}
                >
                  Latest Stories
                </HeadingTag>
                {latestSorted.map((latest, i) => (
                  <div key={latest.id}>
                    <MiniStoryCard latest={latest} />
                    {i === 4 && this.renderPromo()}
                  </div>
                ))}
              </div>
            </div>
          );
        }}
      </HeaderContext.Consumer>
    );
  }
}

const mapStateToProps = state => {
  return {
    latestStories: state.latestStories,
  };
};

LatestStories.propTypes = {
  className: PropTypes.string,
  getLatestStories: PropTypes.func.isRequired,
  latestStories: PropTypes.shape({
    results: PropTypes.arrayOf(
      PropTypes.shape({ published_date: PropTypes.string })
    ).isRequired,
  }).isRequired,
};

export default connect(
  mapStateToProps,
  { getLatestStories }
)(LatestStories);
